'use client'

import Navbar from 'app/components/host-site/components/Navbar'
import Footer from 'app/components/host-site/components/Footer'
import Hero from 'app/components/host-site/components/hierarchy/Hero'
import Structure from 'app/components/host-site/components/hierarchy/Structure'
import Roles from 'app/components/host-site/components/hierarchy/Roles'
import Flow from 'app/components/host-site/components/hierarchy/Flow'
import Scalability from 'app/components/host-site/components/hierarchy/Scalability'
import Ecosystem from 'app/components/host-site/components/hierarchy/Ecosystem'
import CTA from 'app/components/host-site/components/hierarchy/CTA'

/** Host-only hierarchy marketing page (formerly `app/test/hierarchy/page.tsx`). */
export default function HostHierarchyPage() {
    return (
        <main className='min-h-screen bg-[#0a0a0a] text-white'>
            <Navbar />
            <Hero />
            <Structure />
            <Roles />
            <Flow />
            <Scalability />
            <Ecosystem />
            <CTA />
            <Footer />
        </main>
    )
}
